import * as types from "./actionTypes";
import * as vehicleApi from "../../_api/vehicleApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadVehicleSuccess(vehicle) {
  return { type: types.LOAD_VEHICLE_SUCCESS, vehicle };
}

export function updateVehicleSuccess(vehicle) {
  return { type: types.UPDATE_VEHICLE_SUCCESS, vehicle };
}

export function saveVehicleSuccess(vehicle) {
  return { type: types.SAVE_VEHICLE_SUCCESS, vehicle };
}

export function loadVehicle(ClientId, UserId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .getVehicle(ClientId, UserId)
      .then((vehicle) => {
        if (vehicle.length === 0) {
          dispatch(loadVehicleSuccess([{ CurrentState: "None" }]));
        } else {
          vehicle.sort(
            ({ vehicleId: previousID }, { vehicleId: currentID }) =>
              previousID - currentID
          );
          dispatch(loadVehicleSuccess(vehicle));
        }
        return vehicle;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function updateVehicle(vehicleObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .updateVehicle(vehicleObj)
      .then(() => {
        dispatch(saveVehicleSuccess(vehicleObj));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveNewVehicle(vehicleObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .saveVehicle(vehicleObj)
      .then((returnObj) => {
        dispatch(saveVehicleSuccess(returnObj));
        return returnObj.vehicleId;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadVehicleTrim(vehicleModel)
{
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .getVehicleTrim(vehicleModel)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}